import type { GetServerSideProps, NextPage } from "next"
import Image from "next/image"
import { NavBar } from "../../src/components/universal/NavBar"
import { Footer } from "../../src/components/universal/Footer"
import { PageMeta } from "../../src/components/universal/PageMeta"
import { productsList } from "../../src/products"
import { DecodedLink, decodeLink } from "../../src/utils/decodeLink"

import SvgDiscount from "/public/icons/discount.svg"
import SvgCashback from "/public/icons/cashback.svg"
import Link from "next/link"
import { DownloadCTA } from "../../src/components/universal/DownloadCTA"

//Images
type Props = {
  product: DecodedLink
}

const Product: NextPage<Props> = ({ product }) => {
  return (
    <div>
      <PageMeta
        title={product.product_title}
        theme={"#F3F4F7"}
        description={"Download Ruby apps for iOS and Android."}
      >
        <meta property='og:type' content='product' />
        <meta
          property='product:price:amount'
          content={product.sale_price ? product.sale_price : product.price}
        />
        <meta property='product:price:currency' content='USD' />
        <meta property='og:availability' content='instock' />
      </PageMeta>

      <main>
        <NavBar />

        <section>
          <div className='wrapper product-details'>
            <div className='image-wrapper'>
              <img src={product.product_image} alt='' />
            </div>

            <div className='details flex-col'>
              <div className='tags'>
                <div className='tag discount'>
                  <SvgDiscount />
                  {product.discount}
                </div>
                <div className='tag cashback'>
                  <SvgCashback />
                  {product.cash_back}
                </div>
              </div>
              <h1 className='h3'>{product.product_title}</h1>
              <div className='price'>
                {product.sale_price && <h4>${product.sale_price}</h4>}
                <h4 className={" " + (product.sale_price && "old-price")}>
                  ${product.price}
                </h4>
              </div>
              <p className='h6'>By {product.store}</p>

              <Link href={'https://shopruby.onelink.me/Lu2f/pdofxddt'}>
                <button className='btn-lg-label bg-primary secondary'>
                  Get it on ruby
                </button>
              </Link>
            </div>
          </div>
        </section>

        <section>
          <div className='wrapper'>
            <DownloadCTA />
          </div>
        </section>

        <Footer />
      </main>
    </div>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { productId } = context.query
  if (!productId) {
    return {
      notFound: true,
    }
  }

  const encodedUrls = productsList

  let product: DecodedLink | null = null

  encodedUrls.forEach((el) => {
    const res = decodeLink(el)
    if (res && res.slug == productId) {
      product = res
    }
  })

  if (product) {
    return {
      props: {
        product,
      },
    }
  } else {
    return {
      notFound: true,
    }
  }
}

export default Product
